// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppProvider } from './components/AppContext';
import MainPage from './components/MainPage';
import Page1 from './components/Page1';
import ScreenPage from './components/ScreenPage';
import ResultTable from './components/ResultTable';

const App = () => {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/page1" element={<Page1 />} />
          <Route path="/ResultTable" element={<ResultTable />} />

          <Route path="/screenPage" element={<ScreenPage />} />
        </Routes>
      </Router>
    </AppProvider>
  );
};

export default App;
